var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"mobile-nav"},[(_vm.isAuth)?_c('Navbar'):_vm._e()],1),(_vm.isAuth)?_c('SideBar'):_vm._e(),_c('div',{class:_vm.isAuth ? 'custom-container' : ''},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }